@if (transaction()) {
  <!-- SUMMARY -->
  <div id="cart-summary" class="bg-white shadow-lg py-5 rounded-2xl">
    <div class="px-2 pb-2 border-gray-100 border-b">
      <h5 class="px-5 font-bold text-[#E2383F] text-xl">Cart Summary</h5>
      <small class="px-5 text-gray-400 text-base">{{ summaryText() }}</small>
    </div>

    <div class="flex flex-col gap-2 px-5 py-5 border-gray-100 border-b">
      @for (seat of seats; track $index) {
        <div
          class="flex md:flex-wrap flex-nowrap justify-center md:justify-end items-center gap-5 md:gap-0">
          <h5 class="font-bold text-[#535353]">
            Seats
            <span class="font-normal text-[#8B8B8B]">
              (${{ seat.price | number: '1.0' }} x {{ seat.quantity }}):
            </span>
          </h5>
          <div class="ml-0 md:ml-10">
            <h5
              data-cy="summary-seats-price"
              class="bg-[#F2F6FA] p-2 rounded-lg w-28 font-bold text-[#8B8B8B] text-center">
              + ${{
                seats.length === 1
                  ? (totalPriceSeats || 0 | number: '1.2-2')
                  : (seat.total || totalPriceSeats || 0 | number: '1.2-2')
              }}
            </h5>
          </div>
        </div>
      }

      @if (upsellSelected()) {
        <div
          class="flex md:flex-wrap flex-nowrap justify-center md:justify-end items-center gap-5 md:gap-0 mt-4">
          <h5 class="font-normal text-[#8B8B8B]">
            Upgrade:
            <strong class="font-bold text-[#535353]">{{
              upsellSelected()?.name
            }}</strong>
            <span class="font-normal text-[#8B8B8B]">
              (${{ upsellSelected()?.price | number: '1.0' }} x
              {{ totalTransactionSeats() }}) </span
            >:
          </h5>
          <div class="ml-0 md:ml-10">
            <h5
              data-cy="summary-upsell-item"
              class="bg-[#F0F8EE] p-2 rounded-lg w-28 font-bold text-[#8B8B8B] text-center">
              + ${{
                (upsellSelected()?.price || 0) * totalTransactionSeats()
                  | number: '1.2-2'
              }}
            </h5>
          </div>
        </div>
      }

      @if (
        rainoutValue() &&
        transaction().transaction.tdcTransaction?.insuranceRainoutPrice
      ) {
        <div
          class="flex md:flex-wrap flex-nowrap justify-center md:justify-end items-center gap-5 md:gap-0 mt-4">
          <h5 class="flex justify-end">
            <span class="mr-1 font-normal text-[#8B8B8B]">Insurance:</span
            ><strong class="text-[#535353]">Rain-out Insurance:</strong>
          </h5>
          <div class="ml-0 md:ml-10">
            <h5
              data-cy="summary-insurance-rainout-price"
              class="bg-[#F0F8EE] p-2 rounded-lg w-28 font-bold text-[#8B8B8B] text-center">
              + ${{
                transaction().transaction.tdcTransaction
                  ?.insuranceRainoutPrice || 0 | number: '1.2-2'
              }}
            </h5>
          </div>
        </div>
      }
      @if (isTicketFeeEnabled()) {
        @for (serviceCharge of serviceChargesDetails; track $index) {
          @if (serviceCharge.amount) {
            <div
              class="flex md:flex-wrap flex-nowrap justify-center md:justify-end items-center gap-5 md:gap-0 mt-4">
              <h5 class="font-bold text-[#535353]">
                {{ serviceCharge.name }}:
              </h5>
              <div class="ml-0 md:ml-10">
                <h5
                  data-cy="summary-service-charge-fee"
                  class="bg-[#F0F8EE] p-2 rounded-lg w-28 font-bold text-[#8B8B8B] text-center">
                  + ${{ serviceCharge.amount | number: '1.2-2' }}
                </h5>
              </div>
            </div>
          }
        }
      } @else {
        @if (transaction().transaction.tdcTransaction?.serviceCharges) {
          <div
            class="flex md:flex-wrap flex-nowrap justify-center md:justify-end items-center gap-5 md:gap-0 mt-4">
            <h5 class="font-bold text-[#535353]">Total ticket fees:</h5>
            <div class="ml-0 md:ml-10">
              <h5
                data-cy="summary-service-charge-fee"
                class="bg-[#F0F8EE] p-2 rounded-lg w-28 font-bold text-[#8B8B8B] text-center">
                + ${{
                  actualServiceChargesAmountWithoutInsuranceAndUpsell
                    | number: '1.2-2'
                }}
              </h5>
            </div>
          </div>
        }
      }
    </div>

    @if (acquiredUpgrades.length) {
      <div class="flex flex-col gap-2 px-5 py-5 border-gray-100 border-b">
        @for (upgrade of acquiredUpgrades; track upgrade.id) {
          <div
            class="flex md:flex-wrap flex-nowrap justify-center md:justify-end items-center gap-5 md:gap-0">
            <h5 class="flex justify-end max-w-96 text-[#535353]">
              <span class="font-normal text-[#8B8B8B] text-end"
                >For the purchase of
                <span class="font-bold text-[#535353]"
                  >{{ upgrade.goal }} Tickets</span
                >
                <br />
                we have included a
                <span class="font-bold text-[#535353]">{{ upgrade.name }}</span>
              </span>
            </h5>
            <div class="ml-0 md:ml-10">
              <h5
                class="bg-[#E2BA36] bg-opacity-15 p-2 rounded-lg w-28 font-bold text-[#8B8B8B] text-center">
                Free Gift
              </h5>
            </div>
          </div>
        }
      </div>
    }

    <div class="px-5 pt-5">
      <div
        class="flex md:flex-wrap flex-nowrap justify-center md:justify-end items-center gap-5 md:gap-0">
        <h5 class="font-bold">Total Balance:</h5>
        <div class="ml-0 md:ml-10">
          <h5
            data-cy="summary-total-balance"
            class="bg-[#F0F8EE] p-2 rounded-lg w-28 font-bold text-center">
            +
            @if (transaction().transaction.tdcTransaction?.balance) {
              ${{
                transaction().transaction.tdcTransaction?.balance
                  | number: '1.2-2'
              }}
            }
          </h5>
        </div>
      </div>
    </div>
  </div>
}
